import { render, staticRenderFns } from "./MaintenanceScreen.vue?vue&type=template&id=12adc2d1&scoped=true"
import script from "./MaintenanceScreen.vue?vue&type=script&lang=js"
export * from "./MaintenanceScreen.vue?vue&type=script&lang=js"
import style0 from "./MaintenanceScreen.vue?vue&type=style&index=0&id=12adc2d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12adc2d1",
  null
  
)

export default component.exports